(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2539],{

/***/ 18919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.V = function RiEqualizerLine (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"none","d":"M0 0h24v24H0z"}},{"tag":"path","attr":{"d":"M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2h4.17zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2h10.17zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4h4.17zM9 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"}}]}]})(props);
};


/***/ }),

/***/ 58005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Metatags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8002);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40353);





var Metatags = function(param) {
    var metatags = param.metatags;
    if (!metatags || !metatags.length) return null;
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_4__/* .PageContext */ .z);
    var publicRuntimeConfig = _config_constants__WEBPACK_IMPORTED_MODULE_3__/* .PUBLIC_RUNTIME_CONFIG */ .Ls;
    var parsedMetatags = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var title = metatags.find(function(tag) {
            return tag.tag === "title";
        });
        var tags = metatags.filter(function(tag) {
            return tag.tag !== "title";
        }).map(function(tag) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createElement)(tag.tag, {
                key: JSON.stringify(tag),
                name: tag.attributes.name || undefined,
                content: tag.attributes.content || undefined,
                rel: tag.attributes.rel || undefined,
                href: tag.attributes.href || undefined,
                property: tag.attributes.property || undefined
            });
        });
        return {
            title: (title === null || title === void 0 ? void 0 : title.attributes.content) || "",
            tags: tags
        };
    }, [
        metatags
    ]);
    var canonicalUrl = undefined;
    if (pageContext.entity) {
        canonicalUrl = "".concat(publicRuntimeConfig.FRONTEND_URL).concat(pageContext.entity.url);
        if (pageContext.entity.url === "/home") {
            canonicalUrl = publicRuntimeConfig.FRONTEND_URL;
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: parsedMetatags.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            parsedMetatags.tags
        ]
    });
};


/***/ }),

/***/ 82539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SearchPage": function() { return /* reexport */ SearchPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 55 modules
var modal_dist_index_esm = __webpack_require__(5607);
// EXTERNAL MODULE: ./src/components/Layout/Metatags.tsx
var Metatags = __webpack_require__(58005);
// EXTERNAL MODULE: ./src/components/Paragraph/ParagraphRenderer.tsx
var ParagraphRenderer = __webpack_require__(67025);
// EXTERNAL MODULE: ./src/utils/filters.ts
var utils_filters = __webpack_require__(97126);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiEqualizerLine.js
var RiEqualizerLine = __webpack_require__(18919);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/index.esm.js + 2 modules
var checkbox_dist_index_esm = __webpack_require__(53749);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(35610);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoClose.js
var IoClose = __webpack_require__(5981);
// EXTERNAL MODULE: ./src/utils/urls.ts
var urls = __webpack_require__(996);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./src/graphql/LoadFarmSearchResultCount.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LoadFarmSearchResultCount(\n    $nodeId: Int!\n    $page: Int!\n    $filter: FilterInputGrouped\n    $searchQuery: String!\n  ) {\n    farmSearch(\n      nodeId: $nodeId\n      searchQuery: $searchQuery\n      filter: $filter\n      page: $page\n    ) {\n      total\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var QueryLoadFarmSearchResultCount = (0,lib/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./src/utils/getFilterGroups.ts
var getFilterGroups = __webpack_require__(90408);
;// CONCATENATED MODULE: ./src/components/Forms/FilterForm.tsx















var FilterForm = function(param) {
    var data = param.data, initialFilter = param.initialFilter, onSubmitted = param.onSubmitted;
    var ref = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
        defaultValues: {
            filters: initialFilter
        }
    }), register = ref.register, setValue = ref.setValue, handleSubmit = ref.handleSubmit, watch = ref.watch, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var router = (0,next_router.useRouter)();
    var timeoutRef = (0,react.useRef)();
    var ref1 = (0,react.useState)(null), filterResultCount = ref1[0], setFilterResultCount = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(QueryLoadFarmSearchResultCount), 2), loadResultCount = ref2[0], loading = ref2[1].loading;
    var filters = watch("filters");
    (0,react.useEffect)(function() {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (filters.length) {
            setTimeout((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, ref1, ref2, variables, result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            variables = {
                                nodeId: data.id,
                                page: ((ref = router.query) === null || ref === void 0 ? void 0 : ref.page) ? parseInt(router.query.page, 10) : 1,
                                searchQuery: "",
                                filter: {
                                    groups: (0,getFilterGroups/* default */.Z)(data.searchMoreFilter, filters)
                                }
                            };
                            _ctx.next = 4;
                            return loadResultCount({
                                variables: variables
                            });
                        case 4:
                            result = _ctx.sent;
                            setFilterResultCount((result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.farmSearch) === null || ref2 === void 0 ? void 0 : ref2.total) || 0);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })), 500);
        } else {
            setFilterResultCount(null);
        }
        return function() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [
        filters
    ]);
    var onChange = function(event) {
        var value = parseInt(event.target.value, 10);
        if (event.target.checked) {
            setValue("filters", (0,_to_consumable_array/* default */.Z)(filters).concat([
                value
            ]));
        } else {
            setValue("filters", filters.filter(function(id) {
                return id !== value;
            }));
        }
    };
    var onSubmit = function(values) {
        var filterGroups = (0,getFilterGroups/* default */.Z)(data.searchMoreFilter, values.filters);
        var filterQuery = (0,utils_filters/* filtersToQuery */.KV)(filterGroups);
        var newPath = (0,urls/* addParamsToPath */.b)(router.asPath, {
            filters: filterQuery,
            page: null
        });
        router.push(newPath).then(function() {
            onSubmitted && onSubmitted();
        });
    };
    var flattenedFilters = (0,react.useMemo)(function() {
        var flattened = [];
        data.searchMoreFilter.forEach(function(searchMoreFilterParagraph) {
            flattened[searchMoreFilterParagraph.category.id] = searchMoreFilterParagraph.category;
            if (searchMoreFilterParagraph.subCategories.length) {
                searchMoreFilterParagraph.subCategories.forEach(function(subCategory) {
                    flattened[subCategory.id] = subCategory;
                });
            }
        });
        return flattened;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
            borderRadius: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                    children: "Filter"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
                    children: [
                        (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                    fontWeight: "bold",
                                    children: [
                                        "Ihre Auswahl (",
                                        filters.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Wrap */.Eq, {
                                    mt: 1,
                                    children: filters === null || filters === void 0 ? void 0 : filters.map(function(filterId) {
                                        if (!flattenedFilters[filterId]) return null;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* WrapItem */.Uc, {
                                            size: "sm",
                                            alignItems: "center",
                                            as: button_dist_index_esm/* Button */.zx,
                                            borderRadius: "full",
                                            border: "1px solid",
                                            borderColor: "primary",
                                            bg: "primaryLight50",
                                            color: "primary",
                                            px: 3,
                                            py: 1,
                                            onClick: function() {
                                                setValue("filters", filters.filter(function(id) {
                                                    return id !== filterId;
                                                }));
                                            },
                                            children: [
                                                flattenedFilters[filterId].title,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                    ml: 1,
                                                    as: IoClose/* IoClose */.b
                                                })
                                            ]
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                                    borderColor: "gray.300",
                                    opacity: 1,
                                    my: 6
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* VStack */.gC, {
                            alignItems: "flex-start",
                            spacing: 6,
                            divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                                borderColor: "gray.300",
                                opacity: 1
                            }),
                            children: data.searchMoreFilter.map(function(searchMoreFilterParagraph) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                    width: "100%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                            fontWeight: "bold",
                                            mb: 4,
                                            children: searchMoreFilterParagraph.category.title
                                        }),
                                        searchMoreFilterParagraph.subCategories.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* SimpleGrid */.MI, {
                                            width: "100%",
                                            gap: 2,
                                            columns: 2,
                                            children: searchMoreFilterParagraph.subCategories.map(function(subCategory) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                    value: subCategory.id,
                                                    name: "filters",
                                                    isChecked: filters.includes(subCategory.id),
                                                    onChange: onChange,
                                                    children: subCategory.title
                                                }, subCategory.id);
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                            name: "filters",
                                            value: searchMoreFilterParagraph.category.id,
                                            isChecked: filters.includes(searchMoreFilterParagraph.category.id),
                                            onChange: onChange,
                                            children: searchMoreFilterParagraph.category.title
                                        })
                                    ]
                                }, searchMoreFilterParagraph.id);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                            children: [
                                !loading && filterResultCount !== null && "".concat(filterResultCount, " Ergebnis").concat(filterResultCount > 1 || filterResultCount === 0 ? "se" : ""),
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                    color: "primary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "roundBlue",
                            type: "submit",
                            children: "\xdcbernehmen"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Common/LocationSearch.tsx + 2 modules
var LocationSearch = __webpack_require__(35962);
// EXTERNAL MODULE: ./src/context/SearchContext.ts
var SearchContext = __webpack_require__(9829);
;// CONCATENATED MODULE: ./src/components/Node/SearchPage/AskLocationModal.tsx



var AskLocationModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        closeOnOverlayClick: false,
        isOpen: isOpen,
        onClose: onClose,
        size: "xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                        children: "Wo m\xf6chten Sie suchen?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                        pb: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSearch/* LocationSearch */.U, {
                            value: "",
                            onInputChange: function() {},
                            onSubmit: function() {
                                onClose();
                            },
                            width: "100%"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Node/SearchPage/SearchPage.tsx












var SearchPage = function(param) {
    var data = param.data;
    var ref = (0,index_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,index_esm/* useDisclosure */.qY)({
        defaultIsOpen: data.askForLocation && !router.query.lat && !router.query.lng
    }), isOpenAskLocation = ref1.isOpen, onOpenAskLocation = ref1.onOpen, onCloseAskLocation = ref1.onClose;
    var initialFilter = (0,react.useMemo)(function() {
        var parsed = (0,utils_filters/* queryToFilters */.TX)(router.query.filters);
        var filters = [];
        if (parsed) {
            parsed.forEach(function(group) {
                var ref;
                (ref = group.conditions) === null || ref === void 0 ? void 0 : ref.forEach(function(condition) {
                    if (condition.operator === "IN") {
                        condition.value.split(",").forEach(function(value) {
                            filters.push(parseInt(value, 10));
                        });
                    } else {
                        filters.push(parseInt(condition.value, 10));
                    }
                });
            });
        }
        return filters;
    }, [
        router.query
    ]);
    var activeFilter = (0,react.useMemo)(function() {
        var activeFilter = [];
        initialFilter.forEach(function(filterId) {
            data.searchMoreFilter.forEach(function(moreFilterParagraph) {
                if (filterId === moreFilterParagraph.category.id) {
                    activeFilter.push(moreFilterParagraph.category);
                }
                moreFilterParagraph.subCategories.forEach(function(subCategory) {
                    if (filterId === subCategory.id) {
                        activeFilter.push(subCategory);
                    }
                });
            });
        });
        return activeFilter;
    }, [
        initialFilter,
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AskLocationModal, {
                data: data,
                isOpen: isOpenAskLocation,
                onClose: onCloseAskLocation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Metatags/* Metatags */.A, {
                metatags: data.metatags
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                bg: "accent",
                py: 9,
                color: "primary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Container */.W2, {
                    maxW: "container.main",
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                            fontWeight: 500,
                            as: "h1",
                            children: data.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                            mt: 2,
                            mb: 6
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            fontSize: "lg",
                            dangerouslySetInnerHTML: {
                                __html: data.description
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            mt: 9,
                            mb: -16,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                color: "primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                    flexDir: {
                                        base: "column",
                                        md: "row"
                                    },
                                    py: 4,
                                    px: 6,
                                    bg: "white",
                                    borderRadius: "sm",
                                    shadow: "lg",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                            width: {
                                                base: "100%",
                                                md: "auto"
                                            },
                                            mb: {
                                                base: 4,
                                                md: 0
                                            },
                                            mr: {
                                                base: 0,
                                                md: !data.location ? 8 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                                width: {
                                                    base: "100%",
                                                    md: "auto"
                                                },
                                                variant: "outline",
                                                borderRadius: "sm",
                                                onClick: onOpen,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                        mr: 1,
                                                        as: RiEqualizerLine/* RiEqualizerLine */.V
                                                    }),
                                                    "Mehr Filter",
                                                    " ",
                                                    initialFilter.length > 0 && "(".concat(initialFilter.length, ")")
                                                ]
                                            })
                                        }),
                                        !data.location && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSearch/* LocationSearch */.U, {
                                            value: "",
                                            onInputChange: function() {},
                                            onSubmit: function() {},
                                            width: "100%"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isOpen,
                onClose: onClose,
                size: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterForm, {
                        data: data,
                        initialFilter: initialFilter,
                        onSubmitted: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContext/* SearchContext.Provider */.c.Provider, {
                value: {
                    activeFilter: activeFilter,
                    searchMoreFilter: data.searchMoreFilter
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphRenderer/* ParagraphRenderer */.W, {
                    paragraphs: data.content,
                    wrapperProps: {
                        py: 0
                    },
                    getWrapperForParagraph: function(paragraphType) {
                        return paragraphType !== "ParagraphSearchResult" ? "containerSmall" : "container";
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Node/SearchPage/index.ts



/***/ }),

/***/ 67025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ParagraphRenderer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _config_entity_mapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51285);





var getWrapper = function(name, Component) {
    if (name === "container") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            maxW: "container.main",
            children: Component
        });
    } else if (name === "containerSmall") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            maxW: "container.small",
            children: Component
        });
    }
    return Component;
};
var ParagraphRenderer = function(param) {
    var paragraphs = param.paragraphs, wrapperProps = param.wrapperProps, paragraphWrappers = param.paragraphWrappers, getWrapperForParagraph = param.getWrapperForParagraph;
    if (!paragraphs) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "paragraphs",
        children: paragraphs.map(function(paragraph, i) {
            var Component = _config_entity_mapping__WEBPACK_IMPORTED_MODULE_1__/* .EntityMapping */ .f[paragraph.__typename] || null;
            if (!Component) {
                console.warn("[ParagraphRenderer] Paragraph not found", paragraph.__typename);
                return null;
            }
            var InnerComponent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                data: paragraph
            });
            var OuterComponent = InnerComponent;
            if (paragraphWrappers) {
                if (paragraphWrappers[paragraph.__typename]) {
                    OuterComponent = getWrapper(paragraphWrappers[paragraph.__typename], InnerComponent);
                } else if (paragraphWrappers._all) {
                    OuterComponent = getWrapper(paragraphWrappers._all, InnerComponent);
                }
            }
            if (getWrapperForParagraph) {
                var wrapperName = getWrapperForParagraph(paragraph.__typename);
                if (wrapperName) {
                    OuterComponent = getWrapper(wrapperName, InnerComponent);
                }
            }
            if ("contentWidth" in paragraph) {
                if (paragraph.contentWidth === "small") {
                    OuterComponent = getWrapper("containerSmall", InnerComponent);
                }
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                py: 3,
                className: paragraph.__typename,
                pos: "relative",
                __css: {
                    clear: "both"
                }
            }, wrapperProps), {
                children: OuterComponent
            }), "".concat(paragraph.id, "_").concat(i));
        })
    });
};


/***/ }),

/***/ 9829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ SearchContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SearchContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 90408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFilterGroups; }
/* harmony export */ });
function getFilterGroups(searchMoreFilter, filterIds) {
    var filterGroups = [];
    // Build groups
    searchMoreFilter.forEach(function(searchMoreFilterParagraph) {
        // Check if we have any of its categoryTerms active
        var activeItems = [];
        // Can only contain either parent or subcategories
        if (filterIds.includes(searchMoreFilterParagraph.category.id)) {
            filterGroups.push({
                conditions: [
                    {
                        field: "category",
                        value: "".concat(searchMoreFilterParagraph.category.id),
                        operator: "="
                    }, 
                ]
            });
        } else {
            var ref;
            (ref = searchMoreFilterParagraph.subCategories) === null || ref === void 0 ? void 0 : ref.forEach(function(subCategory) {
                if (filterIds.includes(subCategory.id)) {
                    activeItems.push(subCategory.id);
                }
            });
            if (activeItems.length) {
                if (searchMoreFilterParagraph.category.conjunction === "or") {
                    // Any of the following terms
                    filterGroups.push({
                        conditions: [
                            {
                                field: "sub_categories",
                                value: "".concat(activeItems.join(",")),
                                operator: "IN"
                            }, 
                        ]
                    });
                } else {
                    // each of the following terms
                    filterGroups.push({
                        conditions: activeItems.map(function(id) {
                            return {
                                field: "sub_categories",
                                value: "".concat(id),
                                operator: "="
                            };
                        })
                    });
                }
            }
        }
    });
    return filterGroups;
};


/***/ })

}]);